import React, { Component } from 'react'
import { Container } from 'reactstrap';
import SubHeader from './periodical_subheader';
import SchedulingModel from 'shared/components/Models/scheduling_model';
import PendingSchedulingModel from 'shared/components/Models/pending_scheduling_model';
import FacilityList from './facility_list';
import CalendarView from '../CalenderView/index';
import CalenderCard from './calender_card';
import SchedulingCard from 'shared/components/Cards/scheduling_card';
import simpleReactValidator from 'simple-react-validator';
import { connect } from 'react-redux';
import { FaFastForward } from 'react-icons/lib/fa';
import {fetchGroupList,fetchFacilityList,fetchOrgUserList} from '../../actions/actions';
import {fetchPendingPeriodicalsList,fetchSchedulingPeriodicalsList,periodicalsUpdate,schedulePeriodicalUpdate,revertSetOccurrence,resetOnDrag} from 'shared/actions/scheduling_action';
import {fetchFrequencyList} from 'shared/actions/frequency_action';
import AlertSuccess from '../../components/Alerts/alert_success';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import moment from 'moment';

var dateFormat = require('dateformat');



class PeriodicalScheduling extends Component {
    constructor(props) {
        super(props)
        this.validator = new simpleReactValidator();
        this.state = {
            modal: false,
            scheduleModel:false,
            pendingModal:false,
            charged_show: false,
            groupId:"",
            facId:"",
            Pending_p_data:[],
            frequencyTypeId:"",
            frequencyCount:"",
            contract_facility_periodical_id:"",
            pendStartDate:"",
            pendEndDate:"",
            schdEndDate:"",
            userAlocationId:"",
            selected_value:[],
            users_list:[],
            facility_accurenc_id:0,
            blocking: false,
            pending_data:[],
            seduled_data:[],
            pending_current_date:moment(),
            scedule_current_date:moment(),
            current_year:"",
            visible: true,
            show:false,
            occurrence_type:"",
            pstart_date:moment(),
            pend_date:"",
            year_end:moment().endOf("year"),
            periodical_name:"",
            periodical_present: 0,
            scedule_min_date:moment(),
            schdStartDate:moment(),
            selected_schedule_data: null

        }

        this.toggle = this.toggle.bind(this);

        this.pendingModelToggle = this.pendingModelToggle.bind(this);

        this.scheduleModelToggle = this.scheduleModelToggle.bind(this);

        this.onCheck = this.onCheck.bind(this);

        this.groupOnChange=this.groupOnChange.bind(this);

        this.onFacChange=this.onFacChange.bind(this);

        this.btnFilterClick=this.btnFilterClick.bind(this);

        this.pendingModelSubmitClick=this.pendingModelSubmitClick.bind(this);

        this.scheduleModelSubmitClick=this.scheduleModelSubmitClick.bind(this);

        this.pendGetStartDate=this.pendGetStartDate.bind(this);

        this.pendGetEndDate=this.pendGetEndDate.bind(this);

        this.schdEndDateChange=this.schdEndDateChange.bind(this);

        this.schdStartDateChange=this.schdStartDateChange.bind(this);
        
        this.onUserChange=this.onUserChange.bind(this);

        this.next_click=this.next_click.bind(this);
        this.prev_click=this.prev_click.bind(this);
        this.cardClick=this.cardClick.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
        this.revertSetOccurrenceClick = this.revertSetOccurrenceClick.bind(this);
        
        
    }

    componentDidMount() 
    {
        const {dispatch} = this.props
        dispatch(fetchGroupList())
        dispatch(fetchOrgUserList())
        dispatch(fetchFrequencyList())
        var year=(new Date()).getFullYear();
        var year_end=new Date(new Date().getFullYear(), 11, 31)
     //   console.log(year_end);
        this.setState({
            blocking:!this.state.blocking,
            current_year:year,
            //year_end:year_end
        })
    }

    onDismiss() {
        this.setState({ visible: false });
      }
        componentDidUpdate(prevProps, prevState) 
        {
            var that=this;

            if(prevProps.group_items!=this.props.group_items){
                this.setState({
                    blocking: false
                })
            }
            if(prevProps.facility_data!=this.props.facility_data){
                this.setState({
                    blocking: false
                })
            }
           

        if(prevProps.org_user_list_data!=this.props.org_user_list_data)
            {
                    var data=[];
                    this.props.org_user_list_data.map(x=>{
                        data.push({label:x.first_name+" "+x.last_name,value:x.user_id});
                    })
                    this.setState({ users_list: data });
            }
            
            if(prevProps.pending_periodicals_update!=this.props.pending_periodicals_update){
                var fid=this.state.facId;
                if(fid>0){
                    this.props.dispatch(fetchPendingPeriodicalsList(fid));
                    this.props.dispatch(fetchSchedulingPeriodicalsList(fid,this.state.current_year));
                }

                this.setState({visible:true})
            }
            if(prevProps.schedule_periodicals_update!=this.props.schedule_periodicals_update){
                var fid=this.state.facId;
                if(fid>0){
                    this.props.dispatch(fetchSchedulingPeriodicalsList(fid,this.state.current_year));
                    this.props.dispatch(fetchPendingPeriodicalsList(fid));
                }
                this.setState({visible:true})
             }

             if(prevProps.schedule_periodicals_data!=this.props.schedule_periodicals_data){
                 //    console.log("this sate has beedn change");
                this.setState({
                    blocking: false,
                    seduled_data:this.props.schedule_periodicals_data
                })
            }
            if(prevProps.pending_periodicals_data!=this.props.pending_periodicals_data){
                this.setState({
                    pending_data:this.props.pending_periodicals_data
                })
            }
            }


    groupOnChange(e)
    {
        var that=this;
        var getId=e.target.value;
        if(getId!==undefined)
        {
            that.setState({groupId:getId,blocking: !this.state.blocking,pending_data
                :[],seduled_data:[]});
            that.props.dispatch(fetchFacilityList(getId));
        }
        var year=(new Date()).getFullYear();
        this.setState({show:false,current_year:year})
    }

    
    onFacChange(e)
    {
        var that=this;
        var facId=e.target.value;
        this.props.pending_periodicals_data=[];
        if(facId!==undefined)
        {
            that.setState({facId:facId,pending_data
                :[],seduled_data:[]});
        }
        var year=(new Date()).getFullYear();
        this.setState({show:false,current_year:year})
    }

    btnFilterClick(e)
    {
        var that=this;
        if( that.validator.fieldValid('selected_group') && that.validator.fieldValid('selected_facility'))
		{ 
            var facId=this.state.facId;
            if(facId!==undefined)
            {
               that.props.dispatch(fetchPendingPeriodicalsList(facId));
                that.props.dispatch(fetchSchedulingPeriodicalsList(facId,this.state.current_year));
                that.setState({
                    blocking: !this.state.blocking,
                    show:true
                })
            }
        }
        else
        {
            that.validator.showMessages();
			that.forceUpdate();
        }
    }


    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

   


    
    scheduleModelToggle(e) {
        console.log(e);
        this.validator.hideMessages();
        var that =this;
if(e>0){
    var retun_data=[];
    var seduled_data=that.state.seduled_data;
    seduled_data.map(x=>{
           var shedule_element = x.data.filter(function(y) 
           { return y.id == e });
           if(shedule_element.length>0){
           retun_data=shedule_element;
           }})


    var planed_date=retun_data[0].planned_start_date_time;
    var user_array=retun_data[0].user_list;
    //console.log(user_array);
    var selected=[];
    //planed_date=moment(planed_date);
   //(planed_date);
    if(user_array.length>0){

        user_array.map(x=>{
            selected.push({label:x.user_name,value:x.user_id});
        })
    }


   var facility_accurenc_id=e;
   this.setState({
       scheduleModel: !this.state.scheduleModel,
       facility_accurenc_id:e,
       scedule_current_date:planed_date,
       schdStartDate:planed_date,
       selected_value:selected,
       scedule_min_date:planed_date,
       selected_schedule_data: retun_data[0]
   });

}
else
{
    this.setState({
        scheduleModel: !this.state.scheduleModel,
        selected_schedule_data: null
    });
}
       
    }
 

    pendingModelToggle(e)
    {
            var that=this;
            this.validator.hideMessages();
            var list_element = that.props.pending_periodicals_data.filter(function(y) 
            { return y.id == e });

            var pending_current_date=new Date();

            if(list_element.length>0)
            {
                //console.log(list_element[0].occurrence_type)
               // console.log(list_element)
                that.setState({
                    frequencyTypeId:list_element[0].frequency_type_id,
                    occurrence_type:list_element[0].occurrence_type,
                    frequencyCount:list_element[0].frequency_count,
                    contract_facility_periodical_id:e,
                    periodical_name:list_element[0].periodical_name,
                    periodical_present: list_element[0].periodical_present
                 
                }); 

                let today = moment();
            
                that.setState({
                    pendingModal: !that.state.pendingModal,
                    pending_current_date:moment(),
                    pstart_date:list_element[0].periodical_present == 1 ? today.add(1, 'months').startOf("month") : today
                }); 
            }
            else
            {
                that.setState({
                    pendingModal: !that.state.pendingModal,
                    pending_current_date:moment()
                }); 
            }
    }
 


    onCheck() {

        var that = this;
        if (this.state.charged_show == false) {
            that.setState({
                charged_show: true
            });
        } else {
            that.setState({
                charged_show: false
            });
        }

    }

    pendGetStartDate(date)
    {
      //  console.log(date)
        var that = this;
        if(date!=null)
        {
            that.setState({
                pstart_date:date
            });
        }
    }

    
    pendGetEndDate(e)
    {
        var that = this;
        if(e.target.value!=null)
        {
            that.setState({
                pend_date:e.target.value
            });
        }
    }



    schdEndDateChange(e)
    {
        var that = this;
        if(e.target.value!=null)
        {
            that.setState({
                schdEndDate: e.target.value
            });
        }
    }

    
    schdStartDateChange(sdate)
    {
      //  console.log(sdate)
        var that = this;
        
                that.setState({
                    schdStartDate: sdate,
                    scedule_current_date:sdate
            });
       
    }


    onUserChange(selected_value){
       // console.log(selected_value)
		this.setState({ selected_value });
	}

    

    pendingModelSubmitClick()
    {
        
        var that=this;
    
        if( that.validator.fieldValid("pstart_date") && that.validator.fieldValid("pend_date"))
        {
            var pend_date= dateFormat(this.state.year_end,"yyyy-mm-dd");
            var pstart_date= dateFormat(this.state.pstart_date,"yyyy-mm-dd");

            var post={
                contract_facility_periodical_id:that.state.contract_facility_periodical_id,
                start_date:pstart_date,
                end_date:pend_date,
                frequency_id:that.state.occurrence_type,
                occurrence_counter:that.state.frequencyCount,
                status:"1"};
            //    console.log(post);debugger
            that.props.dispatch(periodicalsUpdate(post));
            this.setState({
                pendingModal: !this.state.pendingModal,
                blocking: !this.state.blocking,
                pending_data:[],seduled_data:[]
            });
        }
        else
        {
            that.validator.showMessages();
			that.forceUpdate();
        }


            
      }

      scheduleModelSubmitClick(e)
      {
        // debugger
        var that=this;
        if( that.validator.fieldValid("start_date") &&that.validator.fieldValid("selected_value"))
        {
            var users="";
          var user_list=this.state.selected_value;
          if(user_list.length>0){
            user_list.map(x=>{
                if(users==""){
                    users=x.value;
                }
                else
                {
                  users=users+","+x.value;
                }
            })
          }

          var planned_start_date=dateFormat(this.state.schdStartDate,"yyyy-mm-dd");
          
              var post={
                facility_periodical_occurrence_id:this.state.facility_accurenc_id,
                user_id:users,
                planned_start_date:planned_start_date,
                planned_end_date:planned_start_date,
                status:"1"
                }
             console.log(post);
            this.props.dispatch(schedulePeriodicalUpdate(post));
              this.setState({
                scheduleModel: !this.state.scheduleModel,
                blocking: !this.state.blocking,
                pending_data:[],
                seduled_data:[]
            });

        }
        else
        {
            that.validator.showMessages();
			that.forceUpdate();
        }

      }

      revertSetOccurrenceClick()
      {
        var scheduleData = this.state.selected_schedule_data;
        if(!scheduleData){
            return;
        }

        var post={
            contract_facility_periodical_id:scheduleData.contract_facility_periodical_id,
            start_date:dateFormat(this.state.schdStartDate,"yyyy-mm-dd"),
            end_date:dateFormat(this.state.year_end,"yyyy-mm-dd"),
            frequency_id:scheduleData.frequency_type_id || scheduleData.frequency_id || scheduleData.occurrence_type,
            occurrence_counter:scheduleData.frequency_count || scheduleData.occurrence_counter,
            status:"0"
        };

        this.props.dispatch(revertSetOccurrence(post));
        this.setState({
            scheduleModel:false,
            selected_schedule_data:null,
            blocking: !this.state.blocking,
            pending_data:[],
            seduled_data:[]
        });
      }

      cardClick(e)
      {
          //console.log("cardClick");
          var that=this;
         that.props.dispatch(resetOnDrag(e));
         
         that.setState({
            blocking: !this.state.blocking
        });
      }

      next_click(e)
      {
        var that=this;
        var year=this.state.current_year;
        year=year+1
        that.setState({
            current_year:year
         })
         var facId=this.state.facId;
            if(facId>0)
            {
                that.props.dispatch(fetchPendingPeriodicalsList(facId));
                that.props.dispatch(fetchSchedulingPeriodicalsList(facId,year));
                that.setState({
                    blocking: !this.state.blocking
                })
            }
        //  console.log("next click");
      }

      prev_click(e)
      {
         var that=this;
         var year=this.state.current_year;
         year=year-1
         that.setState({
            current_year:year
         })
       var facId=this.state.facId;
            if(facId>0)
            {
                that.props.dispatch(fetchPendingPeriodicalsList(facId));
                that.props.dispatch(fetchSchedulingPeriodicalsList(facId,year));
                that.setState({
                    blocking: !this.state.blocking
                })
            }
      //    console.log("prev click");
      }

    render() 
    {
        const { group_items,facility_data,pending_periodicals_data,schedule_periodicals_data,org_user_list_data,pending_periodicals_update,schedule_periodicals_update,frequency_data} = this.props
         
        var pending_user_data = [];

        var sceduling_data=[{ id: "1", frequency: "",accurence_count:"",start_date:"",end_date:"",allocate_to:"",status:"" }];
        var that=this;
        return (<div>
            <BlockUi tag="div" blocking={this.state.blocking}>
             <Container fluid={true} >
            <div className="sched-card">
            <SubHeader year={this.state.current_year} show={this.state.show} next_click={this.next_click} prev_click={this.prev_click} validator={this.validator} selected_facility={this.state.facId} selected_group={this.state.groupId} group_data={group_items} onGroupChange={this.groupOnChange}  facilitydata={facility_data} onFacChange={this.onFacChange}  btnFilterClick={this.btnFilterClick}/>

            {pending_periodicals_update!=null && pending_periodicals_update!=""?pending_periodicals_update.success==true?<AlertSuccess visible={this.state.visible} onDismiss={this.onDismiss} color={"success"} alertText={pending_periodicals_update.message}/>:<AlertSuccess visible={this.state.visible} onDismiss={this.onDismiss} color={"danger"} alertText={pending_periodicals_update.message}/>:''}

            {schedule_periodicals_update!=null && schedule_periodicals_update!=""?schedule_periodicals_update.success==true?<AlertSuccess color={"success"} visible={this.state.visible} onDismiss={this.onDismiss} alertText={schedule_periodicals_update.message}/>:<AlertSuccess visible={this.state.visible} onDismiss={this.onDismiss} color={"danger"} alertText={schedule_periodicals_update.message}/>:''}

           {this.state.show!=false?<div className="sched-layout">
                <div className="sched-layout__pending">
                    <div className="sched-col__header">Pending Scheduling</div>
                    <div className="sched-col__body">
                        {this.state.pending_data.length>0
                            ? this.state.pending_data.map(x =>
                                <SchedulingCard key={x.id} id={x.id} value={x.id} is_charged={x.is_seperately_charge} status_code={x.status} periodical_name={x.periodical_name}
                                freq={x.periodical_name.slice(0,1)}
                                date={dateFormat(x.created_date,"dd-mmm")} users={pending_user_data} toggle={this.pendingModelToggle}/>
                              )
                            : <p className="sched-empty-msg">No pending records found.</p>
                        }
                    </div>
                </div>
                <div className="sched-layout__months">
                    <CalenderCard  toggle = {this.scheduleModelToggle} PeriodicData={that.state.seduled_data}  cardClick={this.cardClick}/>
                </div>
            </div>:''}
            </div>

            <SchedulingModel isOpen={this.state.scheduleModel}
            toggle={this.scheduleModelToggle}
            orgUserList={this.state.users_list}
            validator={this.validator}
            onScheduleSubmitClick={this.scheduleModelSubmitClick}
            onRevertClick={this.revertSetOccurrenceClick}
            showRevertButton={this.state.selected_schedule_data && (Number(this.state.selected_schedule_data.status)===1 || Number(this.state.selected_schedule_data.status)===2)}
            scheChange={this.schdStartDateChange}
             handleSelectChange={this.onUserChange} maxDate={this.state.year_end} min={this.state.scedule_min_date}  selected_value={this.state.selected_value} start_date={this.state.schdStartDate}
             />
            <PendingSchedulingModel isOpen={this.state.pendingModal}
            toggle={this.pendingModelToggle}
            frequency={this.state.frequencyTypeId}
            occurrence_count={this.state.frequencyCount}
            validator={this.validator} onSubmitClick={this.onSubmit}
            pendStartDate={this.pendGetStartDate} min={this.state.pending_current_date} pstart_date={this.state.pstart_date}  pend_date={this.state.year_end}
            pendEndDate={this.pendGetEndDate} periodical_name={this.state.periodical_name} pendingModelSubmitClick={this.pendingModelSubmitClick} frequency_data={frequency_data}
                />

        </Container >
        </BlockUi>
        </div>
        )
    }
}


function mapStateToProps(state) 
{
    const {postsBySubreddit,schedulingReducer} = state
    const { group_items:group_items,facility_data:facility_data,org_user_list_data:org_user_list_data,frequency_data:frequency_data } =  postsBySubreddit
    const { pending_periodicals_data:pending_periodicals_data,schedule_periodicals_data:schedule_periodicals_data,
        pending_periodicals_update:pending_periodicals_update,
        schedule_periodicals_update:schedule_periodicals_update } =  schedulingReducer
    return {
        group_items,facility_data,pending_periodicals_data,schedule_periodicals_data,org_user_list_data,pending_periodicals_update,schedule_periodicals_update,frequency_data
      }    
     
}
const AppContainer = connect(
    mapStateToProps
)(PeriodicalScheduling);

export default AppContainer;


// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalScheduling/index.js